import {GetterTree} from 'vuex';
import Panelist from '../ts/PanelistInterface';
import DataVariable from '../../DataVariables/ts/DataVariableInterface';
import DataVariableOption from '../../DataVariables/ts/DataVariableOptionInterface';
import Filter from '../ts/FilterInterface';

export const getters: GetterTree<any, any> = {

    items: (state) => {

        let items: any = [];

        state.panelists.forEach((panelist: Panelist) => {

                let item = {};

                state.selectedVariables.forEach((variable: DataVariable) => {

                    if (panelist.data_variables.hasOwnProperty(variable.uuid)) {

                        const data = panelist.data_variables[variable.uuid];

                        if (variable.type === "radio" && data) {

                            let found = null;

                            if (variable.options) {
                                found = variable.options.find((option: DataVariableOption) => {
                                    return option.unique_id === data
                                });
                            }

                            if (found) {
                                item[variable.uuid] = found.name;
                            }

                        } else if (variable.type === "checkbox" && data) {

                            let optionNames: Array<string> = [];

                            if (variable.options) {
                                variable.options.forEach((option: DataVariableOption) => {
                                    if (data.includes(option.unique_id)) {
                                        optionNames.push(option.name);
                                    }
                                });
                            }

                            item[variable.uuid] = optionNames;
                        } else {
                            // Return straight value
                            item[variable.uuid] = panelist.data_variables[variable.uuid];
                        }
                    }
                });

                item['id'] = panelist.panelist_id;
                items.push(item);
            }
        );

        return items;
    },

    filterActive: (state) => {
        const found = state.filters.find( (filter: Filter) => {
            return filter.model;
        });

        return !!found;
    }
}
